export type FooterTranslationKey = 'customerCare' | 'contactUs' | 'ourCompany' | 'findStore' | 'legalArea' | 'imprint';

interface FooterTranslations {
  customerCare: string;
  contactUs: string;
  ourCompany: string;
  findStore: string;
  legalArea: string;
  imprint: string;
}

export const footerTemplateTranslations: Record<string, FooterTranslations> = {
  en: {
    customerCare: "Customer Care",
    contactUs: "Contact Us",
    ourCompany: "Our Company",
    findStore: "Find a Store",
    legalArea: "Legal Area",
    imprint: "Imprint"
  },
  de: {
    customerCare: "Kundenservice",
    contactUs: "Kontakt",
    ourCompany: "Unser Unternehmen",
    findStore: "Händlersuche",
    legalArea: "Rechtliches",
    imprint: "Impressum"
  }
}; 